import dayjs from "dayjs";
import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

export const DocTeamWorkStatusStatType = {
    IN_UNIT_OUT_TEAM: "IN_UNIT_OUT_TEAM", // 在科不在组
    NO_WORK_STATUS: "NO_WORK_STATUS", // 无工作状态
    NO_WORK_STATUS_IN_UNIT_IN_TEAM: "NO_WORK_STATUS_IN_UNIT_IN_TEAM", // 缺状态、同时在科、在组
};

const initState = {
    month: dayjs(),
    selectedUnitIds: [0],
    hasWorkStatus: true,
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};

export default viewModel;
